module.exports = "https://static.energy5.com/_next/static/images/mapslogos-85658bbb062b74591165c2d7507a81bd.png";